import { stat } from 'fs';

import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { AuthState } from '../auth/store/auth.store';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(private store: Store) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        const mainToken = this.store.selectSnapshot(AuthState.token);

        // E2E Test Exception: Allow tests to access login page even if authenticated
        // Tests can use ?e2e=true query param or set window.__E2E_TEST_MODE__ = true
        const isE2ETest =
            typeof window !== 'undefined' && (state.url.includes('e2e=true') || (window as any).__E2E_TEST_MODE__);

        if (!mainToken) {
            const formatPattern = /^\/auth\/login\/[^/]+@[^/]+\/[a-f0-9]+$/;
            if (
                '/auth/login' === state.url ||
                '/auth/sign-up' === state.url ||
                '/auth/forgot-password' === state.url ||
                state.url.includes('confirmation-code/') ||
                state.url.indexOf('/auth/reset-password') >= 0
            ) {
                return true;
            } else if (formatPattern.test(state.url)) {
                return this.redirectTo(state);
            } else {
                this.store.dispatch(new Navigate(['auth/login']));
                return false;
            }
        }
        if (mainToken) {
            // Skip redirect if this is an E2E test
            if (isE2ETest) {
                return true;
            }
            return this.redirectTo(state);
        }
        return false;
    }
    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.canActivate(route, state);
    }

    redirectTo(state): boolean {
        return true;
    }
}
